import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import { RequireAuth, RedirectIfAuthed } from "./components/RouteGuards";
import { AppShell } from "./components/shell";

// Route-level code splitting: each feature page is its own chunk, loaded on
// demand behind the Suspense boundaries in RouteGuards/AppShell. The shell +
// guards stay in the main bundle so navigation chrome is always instant.
const LoginPage = lazy(() => import("./features/auth/LoginPage").then((m) => ({ default: m.LoginPage })));
const RegisterPage = lazy(() => import("./features/auth/RegisterPage").then((m) => ({ default: m.RegisterPage })));
const InboxPage = lazy(() => import("./features/inbox").then((m) => ({ default: m.InboxPage })));
const TicketsPage = lazy(() => import("./features/tickets").then((m) => ({ default: m.TicketsPage })));
const SettingsPage = lazy(() => import("./features/settings").then((m) => ({ default: m.SettingsPage })));
const ProjectSettingsPage = lazy(() =>
  import("./features/settings").then((m) => ({ default: m.ProjectSettingsPage })),
);
const ReportsPage = lazy(() => import("./features/reports").then((m) => ({ default: m.ReportsPage })));
const AccountPage = lazy(() => import("./features/account").then((m) => ({ default: m.AccountPage })));
const HelpCenterPage = lazy(() => import("./features/helpcenter").then((m) => ({ default: m.HelpCenterPage })));
const AutomationPage = lazy(() => import("./features/automation").then((m) => ({ default: m.AutomationPage })));
const OutboundPage = lazy(() => import("./features/outbound").then((m) => ({ default: m.OutboundPage })));

// basename "/app" matches the Worker mount + Vite `base`. The Worker's notFound
// handler rewrites unknown /app/* paths to /app/ so client routes deep-link.
export const router = createBrowserRouter(
  [
    {
      element: <RedirectIfAuthed />,
      children: [
        { path: "/login", element: <LoginPage /> },
        { path: "/register", element: <RegisterPage /> },
      ],
    },
    {
      element: <RequireAuth />,
      children: [
        {
          element: <AppShell />,
          children: [
            { index: true, element: <InboxPage /> },
            { path: "conversations/:conversationId", element: <InboxPage /> },
            { path: "tickets", element: <TicketsPage /> },
            { path: "tickets/:ticketId", element: <TicketsPage /> },
            { path: "help", element: <HelpCenterPage /> },
            { path: "automation", element: <AutomationPage /> },
            { path: "outbound", element: <OutboundPage /> },
            { path: "reports", element: <ReportsPage /> },
            { path: "settings", element: <SettingsPage /> },
            { path: "project-settings", element: <ProjectSettingsPage /> },
            { path: "account", element: <AccountPage /> },
          ],
        },
      ],
    },
  ],
  { basename: "/app" },
);
